<su-headline h="h1" skin="primary">{{ title | translate }}</su-headline>

<su-slot-tabs [tabs]="tabs" [activeTab]="activeTab"></su-slot-tabs>
<ng-container *ngIf="incidentClassName === incidentClassEnum.BuildingFault">
  <su-slot-tab-content *ngIf="activeTab === tabs[0].id">
    <su-card [card]="cardSummary">
      <div
        card-content
        data-debug="form-confirm"
        *ngIf="ticketDataBuildingFault$ | async as ticketData">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'taskmodule.shared.label__ticketNumber',
              value1: ticketData.ticketNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'taskmodule.shared.label__incidentType',
              value1: ticketData.requestType,
            }
          "></ng-container>

        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.confirm.label__incidentTitle',
              value1: ticketData.name,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.confirm.label__incidentDescription',
              value1: ticketData.description,
            }
          "></ng-container>
        <br />
        <su-headline skin="secondary" h="h2">{{
          'ticket.create.confirm.headline__objectAdress' | translate
        }}</su-headline>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.confirm.label__placeholder',
              value1: ticketData.archObjId,
              value2: ticketData.city,
              value3: ticketData.street,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.confirm.label__roomNumber',
              value1: ticketData.room,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.confirm.label__floor',
              value1: ticketData.floor,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.confirm.label__section',
              value1: ticketData.structuralPart,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.confirm.label__differentAddress',
              value1: ticketData.deviatingAddress,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.headline__search_creator',
              value1: ticketData.creatorName,
              value2: ticketData.creatorEmail,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.headline__search_processor',
              value1: ticketData.reporterName,
              value2: ticketData.reporterEmail,
            }
          "></ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>

  <su-slot-tab-content *ngIf="activeTab === tabs[1].id">
    <su-card
      [card]="cardDocuments"
      *ngIf="ticketDataBuildingFault$ | async as ticketData">
      <div card-content>
        <ng-container>
          <mtx-grid
            #grid
            [columns]="columns"
            [data]="ticketData.documents"
            [rowStriped]="true"
            [noResultText]="'grid.no_results' | translate"
            [cellSelectable]="false">
          </mtx-grid>
        </ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>
</ng-container>

<ng-container *ngIf="incidentClassName === incidentClassEnum.OptionalServices">
  <su-slot-tab-content *ngIf="activeTab === tabs[0].id">
    <su-card [card]="cardSummary">
      <div
        card-content
        data-debug="form-confirm"
        *ngIf="ticketAccessOrderData$ | async as ticketAccessOrderData">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'taskmodule.shared.label__ticketNumber',
              value1: ticketAccessOrderData.ticketNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.summary_access_order.label__short_title',
              value1: ticketAccessOrderData.name,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label:
                'ticket.create.summary_access_order.label__contact_orderer',
              value1: ticketAccessOrderData.creatorName,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label:
                'ticket.create.summary_access_order.label__closure_location',
              value1: ticketAccessOrderData.addressString,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label:
                'ticket.create.summary_access_order.label__delivery_address',
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.summary_access_order.label__description',
              value1: ticketAccessOrderData.description,
            }
          "></ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>

  <su-slot-tab-content *ngIf="activeTab === tabs[1].id">
    <su-card
      [card]="cardDocuments"
      *ngIf="ticketAccessOrderData$ | async as ticketAccessOrderData">
      <div card-content>
        <ng-container>
          <mtx-grid
            #grid
            [columns]="columns"
            [data]="ticketAccessOrderData.documents"
            [rowStriped]="true"
            [noResultText]="'grid.no_results' | translate"
            [cellSelectable]="false">
          </mtx-grid>
        </ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>
</ng-container>

<ng-container *ngIf="incidentClassName === incidentClassEnum.FurnitureOrder">
  <su-slot-tab-content *ngIf="activeTab === tabs[0].id">
    <su-card [card]="cardSummary">
      <div
        card-content
        data-debug="form-confirm"
        *ngIf="ticketDataFurnitureOrder$ | async as ticketDataFurnitureOrder">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'taskmodule.shared.label__ticketNumber',
              value1: ticketDataFurnitureOrder.ticketNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.delivery_address',
              value1: ticketDataFurnitureOrder.addressString
                ? ticketDataFurnitureOrder.addressString
                : ticketDataFurnitureOrder.deliveryAddressFirstName
                  ? ticketDataFurnitureOrder.deliveryAddressFirstName +
                    ' ' +
                    ticketDataFurnitureOrder.deliveryAddressLastName +
                    ', ' +
                    ticketDataFurnitureOrder.deliveryAddressStreet +
                    ', ' +
                    ticketDataFurnitureOrder.deliveryAddressPostalCode +
                    ' ' +
                    ticketDataFurnitureOrder.deliveryAddressCity
                  : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.floor',
              value1: ticketDataFurnitureOrder.floor,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.roomNumber',
              value1: ticketDataFurnitureOrder.roomNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.deskNumber',
              value1: ticketDataFurnitureOrder.deskNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.desired_date.title',
              value1: ticketDataFurnitureOrder.requestedDate
                ? (ticketDataFurnitureOrder.requestedDate | date: 'dd.MM.yyyy')
                : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.description_field.title',
              value1: ticketDataFurnitureOrder.description,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.statement_BAD.title',
              value1:
                ticketDataFurnitureOrder.statementBad === true
                  ? ('ticket.create.furniture_order.statement_BAD.options.statement_added'
                    | translate)
                  : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.electric_desk.title',
              value1:
                ticketDataFurnitureOrder.electricDesk === true
                  ? ('ticket.create.furniture_order.electric_desk.options.statement_added'
                    | translate)
                  : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.special_order.title',
              value1:
                ticketDataFurnitureOrder.specialOrder === true
                  ? ('ticket.create.furniture_order.special_order.options.statement_added'
                    | translate)
                  : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.severe_disability.title',
              value1:
                ticketDataFurnitureOrder.severeDisability === true
                  ? ('ticket.create.furniture_order.severe_disability.options.consultation_rejection'
                    | translate)
                  : null,
            }
          "></ng-container>
        <ng-container *ngIf="!ticketDataFurnitureOrder.addressString">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                label:
                  'ticket.create.furniture_order.additional_agreement.title',
                value1:
                  ticketDataFurnitureOrder.teleWork === true
                    ? ('ticket.create.furniture_order.additional_agreement.options.agreement_added'
                      | translate)
                    : null,
              }
            "></ng-container>
        </ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.contact_person',
              value1: ticketDataFurnitureOrder.creator
                ? ticketDataFurnitureOrder.creator.firstName +
                  ' ' +
                  ticketDataFurnitureOrder.creator.lastName +
                  ', ' +
                  ticketDataFurnitureOrder.creator.email
                : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label:
                'ticket.create.furniture_order.contact_person_onsite_for_inquiries',
              value1: ticketDataFurnitureOrder.contactPerson?.firstName
                ? ticketDataFurnitureOrder.contactPerson.firstName +
                  ' ' +
                  ticketDataFurnitureOrder.contactPerson.lastName +
                  ', ' +
                  ticketDataFurnitureOrder.contactPerson.email
                : null,
            }
          ">
        </ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.furniture_order.psp_element.title',
              value1: ticketDataFurnitureOrder.pspElement,
            }
          "></ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>

  <su-slot-tab-content *ngIf="activeTab === tabs[1].id">
    <su-card
      [card]="cardDocuments"
      *ngIf="ticketDataFurnitureOrder$ | async as ticketDataFurnitureOrder">
      <div card-content>
        <ng-container>
          <mtx-grid
            #grid
            [columns]="columns"
            [data]="ticketDataFurnitureOrder.documents"
            [rowStriped]="true"
            [noResultText]="'grid.no_results' | translate"
            [cellSelectable]="false">
          </mtx-grid>
        </ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>

  <su-slot-tab-content *ngIf="activeTab === tabs[2].id">
    <div [style]="descriptionContainerStyle">
      <div
        class="sub-headline contactDescription"
        [style]="descriptionStyle"
        [innerHtml]="description | safeHtml"></div>
    </div>
    <su-card [card]="cardContact">
      <div card-content>
        <form [formGroup]="form">
          <formly-form
            [form]="form"
            [fields]="formFields"
            [model]="formModel"></formly-form>
        </form>
        <app-spinner-overlay
          [show]="isLoading"
          [label]="
            'ticket.summary.contact.loading_message' | translate
          "></app-spinner-overlay>
      </div>
    </su-card>
  </su-slot-tab-content>
</ng-container>

<ng-container *ngIf="incidentClassName === incidentClassEnum.Relocation">
  <su-slot-tab-content *ngIf="activeTab === tabs[0].id">
    <su-card [card]="cardSummary">
      <div
        card-content
        data-debug="form-confirm"
        *ngIf="ticketDataRelocation$ | async as ticketDataRelocation">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'taskmodule.shared.label__ticketNumber',
              value1: ticketDataRelocation.ticketNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.location_of_origin.incidentDescription',
              value1: ticketDataRelocation.description,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.location_of_origin.firstCheckBox',
              value1:
                ticketDataRelocation.infoConsent === true
                  ? ('shared.yes' | translate)
                  : ('shared.no' | translate),
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.location_of_origin.secondCheckBox',
              value1:
                ticketDataRelocation.spaceRequestReturn === true
                  ? ('shared.yes' | translate)
                  : ('shared.no' | translate),
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.location_of_origin.worker',
              value1: ticketDataRelocation.creator.firstName
                ? ticketDataRelocation.creator.firstName +
                  ' ' +
                  ticketDataRelocation.creator.lastName +
                  ', ' +
                  ticketDataRelocation.creator.email
                : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.location_of_origin.contact_person',
              value1: ticketDataRelocation.contactPerson.firstName
                ? ticketDataRelocation.contactPerson.firstName +
                  ' ' +
                  ticketDataRelocation.contactPerson.lastName +
                  ', ' +
                  ticketDataRelocation.contactPerson.email
                : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.location_of_origin.location',
              value1: ticketDataRelocation.addressStringOrigin
                ? ticketDataRelocation.addressStringOrigin
                : ticketDataRelocation.originAddressFirstName
                  ? ticketDataRelocation.originAddressFirstName +
                    ' ' +
                    ticketDataRelocation.originAddressLastName +
                    ', ' +
                    ticketDataRelocation.originAddressStreet +
                    ', ' +
                    ticketDataRelocation.originAddressPostalCode +
                    ' ' +
                    ticketDataRelocation.originAddressCity
                  : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.floor',
              value1: ticketDataRelocation.originFloor,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.roomNumber',
              value1: ticketDataRelocation.originRoomNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.deskNumber',
              value1: ticketDataRelocation.originDeskNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.location_of_origin.target',
              value1: ticketDataRelocation.addressStringTarget
                ? ticketDataRelocation.addressStringTarget
                : ticketDataRelocation.targetAddressFirstName
                  ? ticketDataRelocation.targetAddressFirstName +
                    ' ' +
                    ticketDataRelocation.targetAddressLastName +
                    ', ' +
                    ticketDataRelocation.targetAddressStreet +
                    ', ' +
                    ticketDataRelocation.targetAddressPostalCode +
                    ' ' +
                    ticketDataRelocation.targetAddressCity
                  : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.floor',
              value1: ticketDataRelocation.targetFloor,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.roomNumber',
              value1: ticketDataRelocation.targetRoomNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.deskNumber',
              value1: ticketDataRelocation.targetDeskNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'relocation.desired_date.title',
              value1: ticketDataRelocation.requestedDate
                ? (ticketDataRelocation.requestedDate | date: 'dd.MM.yyyy')
                : null,
            }
          "></ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>

  <su-slot-tab-content *ngIf="activeTab === tabs[1].id">
    <su-card
      [card]="cardDocuments"
      *ngIf="ticketDataRelocation$ | async as ticketDataRelocation">
      <div card-content>
        <ng-container>
          <mtx-grid
            #grid
            [columns]="columns"
            [data]="ticketDataRelocation.documents"
            [rowStriped]="true"
            [noResultText]="'grid.no_results' | translate"
            [cellSelectable]="false">
          </mtx-grid>
        </ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>

  <su-slot-tab-content *ngIf="activeTab === tabs[2]?.id">
    <div [style]="descriptionContainerStyle">
      <div
        class="sub-headline contactDescription"
        [style]="descriptionStyle"
        [innerHtml]="description | safeHtml"></div>
    </div>
    <su-card [card]="cardContact">
      <div card-content>
        <form [formGroup]="form">
          <formly-form
            [form]="form"
            [fields]="formFields"
            [model]="formModel"></formly-form>
          <app-spinner-overlay
            [show]="isLoading"
            [label]="
              'ticket.summary.contact.loading_message' | translate
            "></app-spinner-overlay>
        </form>
      </div>
    </su-card>
  </su-slot-tab-content>
</ng-container>

<ng-container *ngIf="incidentClassName === incidentClassEnum.AreaRequest">
  <su-slot-tab-content *ngIf="activeTab === tabs[0].id">
    <su-card [card]="cardSummary">
      <div
        card-content
        data-debug="form-confirm"
        *ngIf="ticketDataAreaRequest$ | async as ticketDataAreaRequest">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'taskmodule.shared.label__ticketNumber',
              value1: ticketDataAreaRequest.ticketNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.space_request.short_title',
              value1: ticketDataAreaRequest.name,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.space_request.description',
              value1: ticketDataAreaRequest.description,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.space_request.requested_location',
              value1: ticketDataAreaRequest.addressString,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.space_request.requested_date',
              value1: ticketDataAreaRequest.requestedDate
                ? (ticketDataAreaRequest.requestedDate | date: 'dd.MM.yyyy')
                : null,
            }
          "></ng-container>
        <div>
          <div class="confirm-label">
            <span>
              {{
                'ticket.create.space_request.requested_area.title' | translate
              }}: <br /><br />
            </span>
          </div>
          <div class="grid-container">
            <span class="confirm-value">
              <mtx-grid
                [columns]="areaRequestColumns"
                [data]="ticketDataAreaRequest.areaRequirements"
                [rowStriped]="true"
                [showPaginator]="false"
                [noResultText]="''"
                [cellSelectable]="false">
              </mtx-grid>
            </span>
          </div>
        </div>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.headline__search_creator',
              value1: ticketDataAreaRequest.creator.firstName
                ? ticketDataAreaRequest.creator.firstName +
                  ' ' +
                  ticketDataAreaRequest.creator.lastName +
                  ', ' +
                  ticketDataAreaRequest.creator.email
                : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.label__processor',
              value1: ticketDataAreaRequest.contactPerson.firstName
                ? ticketDataAreaRequest.contactPerson.firstName +
                  ' ' +
                  ticketDataAreaRequest.contactPerson.lastName +
                  ', ' +
                  ticketDataAreaRequest.contactPerson.email
                : null,
            }
          "></ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>

  <su-slot-tab-content *ngIf="activeTab === tabs[1].id">
    <su-card
      [card]="cardDocuments"
      *ngIf="ticketDataAreaRequest$ | async as ticketDataAreaRequest">
      <div card-content>
        <ng-container>
          <mtx-grid
            #grid
            [columns]="columns"
            [data]="ticketDataAreaRequest.documents"
            [rowStriped]="true"
            [noResultText]="'grid.no_results' | translate"
            [cellSelectable]="false">
          </mtx-grid>
        </ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>
</ng-container>

<ng-container *ngIf="incidentClassName === incidentClassEnum.AreaReturn">
  <su-slot-tab-content *ngIf="activeTab === tabs[0].id">
    <su-card [card]="cardSummary">
      <div
        card-content
        data-debug="form-confirm"
        *ngIf="ticketDataAreaReturn$ | async as ticketDataAreaReturn">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'taskmodule.shared.label__ticketNumber',
              value1: ticketDataAreaReturn.ticketNumber,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'area_return.summary.short_title',
              value1: ticketDataAreaReturn.name,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'area_return.summary.description',
              value1: ticketDataAreaReturn.description,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'area_return.label__organisation_unit',
              value1: ticketDataAreaReturn.orgUnit,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'area_return.label__department_similar',
              value1: ticketDataAreaReturn.department,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'area_return.label__search',
              value1: ticketDataAreaReturn.addressString,
            }
          "></ng-container>
        <div *ngIf="!ticketDataAreaReturn.billingAreaId">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                label: 'area_return.label__cost_center',
                value1: ticketDataAreaReturn.costCenterId,
              }
            "></ng-container>
        </div>
        <div *ngIf="ticketDataAreaReturn.billingAreaId">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                label: 'area_return.label__billingArea',
                value1: ticketDataAreaReturn.billingAreaId,
              }
            "></ng-container>
        </div>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'area_return.label__desired_date',
              value1: ticketDataAreaReturn.requestedDate
                ? (ticketDataAreaReturn.requestedDate | date: 'dd.MM.yyyy')
                : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'area_return.summary.costcenter_society',
              value1: ticketDataAreaReturn.costCenterSociety,
            }
          "></ng-container>

        <div>
          <div class="confirm-label">
            <span> {{ 'area_return.label__selected_uses' | translate }}: </span>
          </div>
          <div
            *ngIf="
              ticketDataAreaReturn.costCenterUsages?.length > 0;
              else sbuUsages
            ">
            <div
              *ngFor="
                let usage of ticketDataAreaReturn.costCenterUsages;
                let i = index
              ">
              <div class="confirm-value">
                <span>
                  {{ 'area_return.label__room' | translate }}:
                  {{ usage.room }}
                </span>
                <span *ngIf="usage.workSpace">
                  <br />
                  {{ 'area_return.label__workSpace' | translate }}:
                  {{ usage.workSpace }}
                </span>
                <span *ngIf="!usage.workSpace">
                  <br />
                  {{ 'area_return.label__area' | translate }}:
                  {{ usage.floorArea }} m²
                </span>
                <br />
                <span>
                  {{ 'area_return.label__endOfUse' | translate }}:
                  {{ ticketDataAreaReturn.requestedDate | date: 'dd.MM.yyyy' }}
                </span>
                <br />
                <span>
                  {{ 'area_return.label__validUntil' | translate }}:
                  {{ usage.usageUntil | date: 'dd.MM.yyyy' }}
                </span>
                <br />
                <span>
                  {{ 'area_return.label__costCenter' | translate }}:
                  {{ usage.costCenterId }}
                </span>
                <br />
              </div>
              <hr
                *ngIf="i < ticketDataAreaReturn.costCenterUsages?.length - 1" />
            </div>
          </div>
          <ng-template #sbuUsages>
            <div
              *ngIf="
                ticketDataAreaReturn.strategicBusinessUnitUsages?.length > 0;
                else noData
              ">
              <div
                *ngFor="
                  let usage of ticketDataAreaReturn.strategicBusinessUnitUsages;
                  let i = index
                ">
                <div class="confirm-value">
                  <span>
                    {{ 'area_return.label__endOfUse' | translate }}:
                    {{ usage.requestedDate | date: 'dd.MM.yyyy' }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__costCenter' | translate }}:
                    {{ usage.costCenterId }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__quantity_current' | translate }}:
                    {{ usage.cntWorkspaces }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__quantity_selection' | translate }}:
                    {{ usage.cntWorkspacesRequested }}
                  </span>
                  <br />
                  <span>
                    {{ 'area_return.label__validUntil' | translate }}:
                    {{ usage.usageUntil | date: 'dd.MM.yyyy' }}
                  </span>
                  <br />
                </div>
                <hr
                  *ngIf="
                    i <
                    ticketDataAreaReturn.strategicBusinessUnitUsages?.length - 1
                  " />
              </div>
            </div>
          </ng-template>
          <ng-template #noData>
            <span class="confirm-value">--</span>
          </ng-template>
        </div>
        <br />
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.headline__search_creator',
              value1: ticketDataAreaReturn.creator.firstName
                ? ticketDataAreaReturn.creator.firstName +
                  ' ' +
                  ticketDataAreaReturn.creator.lastName +
                  ', ' +
                  ticketDataAreaReturn.creator.email
                : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.label__processor',
              value1: ticketDataAreaReturn.contactPerson.firstName
                ? ticketDataAreaReturn.contactPerson.firstName +
                  ' ' +
                  ticketDataAreaReturn.contactPerson.lastName +
                  ', ' +
                  ticketDataAreaReturn.contactPerson.email
                : null,
            }
          "></ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>

  <su-slot-tab-content *ngIf="activeTab === tabs[1].id">
    <su-card
      [card]="cardDocuments"
      *ngIf="ticketDataAreaReturn$ | async as ticketDataAreaReturn">
      <div card-content>
        <ng-container>
          <mtx-grid
            #grid
            [columns]="columns"
            [data]="ticketDataAreaReturn.documents"
            [rowStriped]="true"
            [noResultText]="'grid.no_results' | translate"
            [cellSelectable]="false">
          </mtx-grid>
        </ng-container>
      </div>
    </su-card>
  </su-slot-tab-content>
</ng-container>

<ng-container
  *ngIf="
    incidentClassName === incidentClassEnum.UserAdministration ||
    incidentClassName === incidentClassEnum.UserCreation ||
    incidentClassName === incidentClassEnum.RoleRemoval ||
    incidentClassName === incidentClassEnum.RoleRequest
  ">
  <su-slot-tab-content *ngIf="activeTab === tabs[0].id">
    <su-card [card]="cardSummary">
      <div
        card-content
        data-debug="form-confirm"
        *ngIf="
          ticketDataUserAdministration$ | async as ticketDataUserAdministration
        ">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'user_administration.summary.label__title',
              value1: ticketDataUserAdministration.name,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'user_administration.summary.label__ticketType',
              value1: ticketDataUserAdministration.incidentClass,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'user_administration.summary.label__status',
              value1: ticketDataUserAdministration.incidentStatus,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'user_administration.summary.label__createdOn',
              value1: ticketDataUserAdministration.createdOn
                ? (ticketDataUserAdministration.createdOn + 'Z'
                    | date: 'dd.MM.yyyy HH:mm') +
                  ' ' +
                  ('helpdesk.ticket.list.extended_time_str' | translate)
                : null,
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'ticket.create.headline__search_creator',
              value1: ticketDataUserAdministration.creator.firstName
                ? ticketDataUserAdministration.creator.firstName +
                  ' ' +
                  ticketDataUserAdministration.creator.lastName +
                  ', ' +
                  ticketDataUserAdministration.creator.email +
                  (ticketDataUserAdministration.creator?.organisation?.name !==
                  null
                    ? ', ' +
                      ticketDataUserAdministration.creator.organisation.name
                    : '')
                : ('user_administration.summary.label__systemTicket'
                  | translate),
            }
          "></ng-container>
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              label: 'user_administration.summary.label__user',
              value1: ticketDataUserAdministration.user.firstName
                ? ticketDataUserAdministration.user.firstName +
                  ' ' +
                  ticketDataUserAdministration.user.lastName +
                  ', ' +
                  ticketDataUserAdministration.user.email
                : null,
            }
          "></ng-container>
        <div>
          <div class="confirm-label">
            <span>
              {{
                'user_administration.summary.label__changedRolesStatus'
                  | translate
              }}: <br /><br />
            </span>
          </div>
          <div class="grid-container">
            <span class="confirm-value">
              <mtx-grid
                [columns]="roleIncidentColumns"
                [data]="ticketDataUserAdministration.roleIncidents"
                [rowStriped]="true"
                [showPaginator]="false"
                [noResultText]="''"
                [cellSelectable]="false">
              </mtx-grid>
            </span>
          </div>
        </div>
      </div>
    </su-card>
  </su-slot-tab-content>
</ng-container>

<ng-template
  #itemTemplate
  let-label="label"
  let-value1="value1"
  let-value2="value2"
  let-value3="value3">
  <div class="item-container">
    <div class="confirm-label">
      <span>{{ label | translate }}</span
      >:
    </div>
    <span class="confirm-value" *ngIf="value1">
      <ng-container>{{ value1 }}</ng-container>
      <ng-container *ngIf="value2">, {{ value2 }}</ng-container>
      <ng-container *ngIf="value3">, {{ value3 }}</ng-container>
    </span>
    <span class="confirm-value" *ngIf="!value1">--</span>
  </div>
</ng-template>

<ng-template
  #documentActionsTemplate
  let-row
  let-index="index"
  let-col="colDef">
  <div class="button-container">
    <su-button
      skin="secondary"
      icon="download"
      [title]="'documents.tooltip__download' | translate"
      (onClick)="downloadDocument($event, row)"
      [ariaLabel]="'documents.tooltip__download' | translate">
    </su-button>
  </div>
</ng-template>
